<app-edit-currency-dlg [(display)]="displayCurrencyDialog"
                       [header]="headerText"
                       [currencyRate]="editCurrencyRatesItem"
                       [closeOnConfirm]="false"
                       [saveError]="saveError"
                       [saving]="saving"
                       (currRateEntry)="onEditCurrency($event)">

</app-edit-currency-dlg>

  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
    </ng-template>

    <ng-template pTemplate="right">
      <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
                pTooltip="Обновить таблицу " tooltipPosition="top"></p-button>

      <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                pTooltip="Сбросить фильтр" tooltipPosition="top"></p-button>

      <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
                pTooltip="Экспортировать список " tooltipPosition="top" [disabled]="!totalRecords"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table #CRT1
           [value]="currencyRatesList"
           [paginator]="rows<totalRecords"
           [rows]="rows"
           [totalRecords]="totalRecords"
           [loading]="loading"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,25,50,100]"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} записей"
           selectionMode="single"
           [(selection)]="selectedCurrencyRatesItem"
           dataKey="CRID"
           [rowHover]="true"
           (onRowSelect)="onRowSelect($event)"
           (onRowUnselect)="onRowUnselect($event)"
           styleClass="p-datatable-gridlines p-datatable-striped"
           [resizableColumns]="true"
           columnResizeMode="fit"
           (onFilter)="onFilterTable($event)"
           filterDelay="300"
           sortField="CRDATE"
           sortOrder="-1"
           (onSort)="onSortCurrRates($event)">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="CURCODE" pResizableColumn style="width: 20% !important">Код валюты <p-sortIcon field="CURCODE"></p-sortIcon></th>
        <th pSortableColumn="CURNAME" pResizableColumn style="width: auto !important">Название <p-sortIcon field="CURNAME"></p-sortIcon></th>
        <th pSortableColumn="CRDATE" pResizableColumn style="width: 15% !important">Дата <p-sortIcon field="CRDATE"></p-sortIcon></th>
        <th pSortableColumn="CRVALUE" pResizableColumn style="width: 15% !important">Курс <p-sortIcon field="CRVALUE"></p-sortIcon></th>
      </tr>
      <tr>
        <th style="overflow: visible !important">
          <p-multiSelect [options]="currencyList" placeholder="Все валюты"
                         [(ngModel)]="currencyListDS" (onChange)="CRT1.filter($event.value, 'CURCODE', 'inArray')"
                         styleClass="p-column-filter p-dropdown-filter-style" optionLabel="CURCODE"
                         [maxSelectedLabels]="2" [selectedItemsLabel]="'{0} валюты выбрано'">
          </p-multiSelect>
        </th>
        <th>
          <input pInputText type="text" placeholder="Поиск" [value]="CRT1.filters['CURNAME'] ? CRT1.filters['CURNAME'].value : ''" class="p-column-filter" (input)="CRT1.filter($event.target.value, 'CURNAME', 'contain')">
        </th>
        <th>
          <input pInputText type="date" placeholder="Поиск" [value]="CRT1.filters['CRDATE'] ? CRT1.filters['CRDATE'].value : ''" class="p-column-filter" (input)="CRT1.filter($event.target.value, 'CRDATE', 'before')">
        </th>
        <th>
          <input pInputText type="number" placeholder="Поиск" [value]="CRT1.filters['CRVALUE'] ? CRT1.filters['CRVALUE'].value : ''" class="p-column-filter" (input)="CRT1.filter($event.target.value, 'CRVALUE', 'gtOrZero')">
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-currencyrates>
      <tr [pSelectableRow]="currencyrates">
        <td style="overflow: visible !important" [pTooltip]="'CURID: ' + currencyrates.CURID" tooltipPosition="top">{{currencyrates.CURCODE}}</td>
        <td>{{currencyrates.CURNAME}}</td>
        <td style="overflow: visible !important">{{currencyrates.CRDATE | date: 'dd/MM/yyyy HH:mm'}}</td>
        <td>
          {{currencyrates.CRVALUE | number:'1.4-4'}}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">

      <div class="grid mt-2">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить валюту" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="p-button-success ml-2 hide-label"
                      pTooltip="Добавить новую валюту" tooltipPosition="top"></p-button>
            <p-button label="Редактировать валюту" icon="pi pi-plus" (onClick)="onEditRow($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="!selection"
                      pTooltip="Редактировать валюту" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все валюты" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mr-2 hide-label" [disabled]="true"
                      pTooltip="Убрать все валюты" tooltipPosition="top"></p-button>
            <p-button label="Удалить валюту" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mr-2 hide-label" [disabled]="true || (!selection)"
                      pTooltip="Убрать выбранную валюту" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">нет данных для загрузки</td>
      </tr>
    </ng-template>
  </p-table>
